/**
 * 积分商品管理
 */
import { POINTSGOODS } from '../types';

export default {
    name: `${POINTSGOODS}`,
    path: '/pointsGoods',
    component: () => import(/* webpackChunkName: 'pointsGoods' */ '@/views/pointsGoods/'),
    redirect: { name: `${POINTSGOODS}Index` },
    meta: {
        title: '积分商品管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${POINTSGOODS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'pointsGoods' */ '@/views/pointsGoods/home/Home.vue'),
        },
        {
            name: `${POINTSGOODS}Add`,
            path: 'add',
            component: () => import(/* webpackChunkName: 'pointsGoods' */ '@/views/pointsGoods/add/Add.vue'),
            permission: true,
        },
        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${POINTSGOODS}Detail`,
            path: 'detail',
            component: () => import(
                    /* webpackChunkName: 'pointsGoods' */ '@/views/pointsGoods/detail/Detail.vue'
                ),
            permission: true,
        },
    ],
};
